@if (node) {
  <div class="node-container" [ngClass]="'parent-id-'+ $safeNavigationMigration(node?.parentId)">
    <div class="node">
      <span>{{ node.name }}</span>
      <span class="actions">
        <i class="fa fa-ellipsis-v" (click)="isActionMenuOpen = !isActionMenuOpen"
        (clickOutside)="isActionMenuOpen = false"></i>
        @if (isActionMenuOpen) {
          <i class="ml-2 fas fa-pen edit" (click)="editOrganization(node)"></i>
          <i class="fas fa-trash delete" (click)="deleteOrganization(node)"></i>
        }
      </span>
      <div class="add-node" (click)="addOrganization(node)">
        <i class="fas fa-plus"></i>
      </div>
      @if (node.children?.length) {
        <div class="connector-line"></div>
      }
    </div>
    @if (node.children?.length) {
      <div class="children">
        <div class="child-nodes">
          @for (child of node.children; track trackById($index, child)) {
            <app-hierarchy-node [node]="child">
            </app-hierarchy-node>
          }
        </div>
      </div>
    }
  </div>
}